module.exports = __webpack_public_path__ + "static/media/6.0620c755.jpg";